import axiosInstance from '../../../api/axiosConfig';
import { Campaign } from '../../../types/campaign';

export const importCampaign = async (formData: any) => {
    const response = await axiosInstance.post('/campaign/import', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const confirmImportCampaign = async (campaign: any) => {
    const response = await axiosInstance.post<Campaign>('/campaign/confirm-import', campaign);
    return response?.data;
};

export const exportExcelCampaign = async (id: number) => {
    const response = await axiosInstance.post(`/campaign/export-excel/${id}`, undefined, {
        responseType: 'blob',
    });
    return response?.data;
};

export const createCampaign = async () => {
    const response = await axiosInstance.post('/campaign');
    return response?.data;
};

export const getCampaigns = async () => {
    const response = await axiosInstance.get<Campaign[]>('/campaign');
    return response?.data;
};

export const getCampaign = async (id: number) => {
    const response = await axiosInstance.get<Campaign>(`/campaign/${id}`);
    return response?.data;
};

export const updateCampaign = async (campaign: Campaign) => {
    const response = await axiosInstance.patch<Campaign>(`/campaign/${campaign.id}`, campaign);
    return response?.data;
};

export const updateOrderStatusByCampaign = async (campaignId: number, body: any) => {
    const response = await axiosInstance.patch<Campaign>(`/campaign/status/${campaignId}`, body);
    return response?.data;
};

export const updateCampaignClickTag = async (id: number, formData: any) => {
    const response = await axiosInstance.post<Campaign>(`/campaign/click-tag/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const forceCacheUpdate = async () => {
    const response = await axiosInstance.post('/campaign/force-cache-update');
    return response?.data;
};
